import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import { handleModalHubspot } from 'actions/modal'

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogWrapper = withStyles(theme => ({
  root: {

  },
  paperWidthSm: {
    maxWidth: '1500px!important'
  }
}))(Dialog);

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);


const ModalHubspot = ({
  modal,
  handleModalHubspot,
  children,
  title,
  height
}) => {
  return (
    <div>
      <DialogWrapper
        aria-labelledby="customized-dialog-title"
        open={modal.isOpenHubspot}
        onClose={() => handleModalHubspot()}
      >
        <React.Fragment>
          {
            title && (
              <DialogTitle id="customized-dialog-title" onClose={() => handleModalHubspot()}>
                {title}
              </DialogTitle>
            )
          }
          <DialogContent dividers style={{ minHeight: height ? `${height}rem` : '25rem' }}>
            {children}
          </DialogContent>
        </React.Fragment>
      </DialogWrapper>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  handleModalHubspot: () => dispatch(handleModalHubspot())
});

const mapStateToProps = (state) => ({
  modal: state.modal
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalHubspot);